<template>
  <section class="main content">

    <router-view/>

  </section>
</template>

<script>
  export default {
    name: 'LayoutContent'
  }
</script>

<style lang="scss" scoped>
  .main.content {
    height: 100%;
  }
</style>
